import App from '@/models/App'
import dayjs from 'dayjs'

export default class ShipLaborTally extends App {
    static get entity() {
        return 'ShipLaborTally'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static findByDate(date) {
        return this.query().where('attendanceAt', date).first()
    }
    static weeklyAlertItems(sailorId) {
        return this.query()
            .where('shipSailorId', sailorId)
            .where('workingTimeWeeklyAlert', 1)
            .get()
    }
    static workingTimeWeeklyOfToday(sailorId) {
        const today = dayjs().format('YYYY-MM-DD')
        return this.query()
            .where('shipSailorId', sailorId)
            .where('attendanceAt', today)
            .first()?.workingTimeWeekly
    }
    static fields() {
        return {
            id: this.attr(''),
            shipSailorId: this.attr(''),
            attendanceAt: this.attr(''),
            workingTime: this.attr(''),
            workingTimeAlert: this.attr(''),
            overtimeWork: this.attr(''),
            totalOvertime: this.attr(''),
            totalOvertimeAlert: this.attr(''),
            holidayWork: this.attr(''),
            nighttimeWork: this.attr(''),
            workingTimeWeekly: this.attr(''),
            workingTimeWeeklyAlert: this.attr(''),
            indemnityOvertime: this.attr(''),
            indemnityAdditionalCount: this.attr(''),
            safeWork: this.attr(''),
            restingWork: this.attr(''),
            restingWorkAlert: this.attr(''),
            divisionRestingLongest: this.attr(''),
            divisionRestingSum: this.attr(''),
            divisionRestingThird: this.attr(''),
            divisionRestingTimeAlert: this.attr(''),
            restingWeekly: this.attr(''),
            restingWeeklyAlert: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, shipSailorId = '', params, save = true) {
                return this.get(
                    `${shipId}${shipSailorId ? `/sailors/${shipSailorId}` : ''} /labor/tally`,
                    {
                        params,
                        save,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(shipId, shipSailorId, params) {
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/labor/tally`,
                    App.patch(params),
                    {
                        params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateIndemnity(shipId, shipSailorId, params) {
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/labor/tally/indemnity`,
                    App.patch(params),
                    {
                        params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
